import React, { useEffect, useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const menuProps = {
  // define a origem de ancoragem do menu em relação ao componente pai.
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      marginTop: 8, // adiciona um espaço entre o Select e o menu de seleção
    },
  },
};

export default function CheckMarksDropdown({
  data,
  ids,
  onChange,
  margin,
  label,
  names,
}) {
  const [selectedNames, setSelectedNames] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  function updateSelectedItemsIds(selectedItemId) {
    if (selectedIds.includes(selectedItemId)) {
      const newSelectedIds = selectedIds.filter((id) => id !== selectedItemId);
      setSelectedIds(newSelectedIds);
      return newSelectedIds;
    } else {
      const newSelectedIds = [...selectedIds, selectedItemId];
      return newSelectedIds;
    }
  }

  function updateSelectedNames(selectedItemsName) {
    const newSelected = selectedItemsName.filter(
      (item, index) => selectedItemsName.indexOf(item) === index,
    );
    setSelectedNames(newSelected);
  }

  const onChangeHandler = (e) => {
    // MUI Select multiple returns an array of selected values (we use ids as values)
    const selected = e.target.value || [];
    // ensure numbers
    const selectedIds = selected.map((v) => Number(v));
    setSelectedIds(selectedIds);
    // derive names from data
    const selectedNames = data
      .filter((item) => selectedIds.indexOf(item.id) > -1)
      .map((item) => item.name);
    setSelectedNames(selectedNames);

    onChange(selectedIds);
  };

  // useEffect(() => {
  //   if (ids.length > 0) setSelectedIds(ids);
  // }, [ids]);
  // useEffect(() => {
  //   if (names.length > 0) setSelectedNames(names);
  // }, [names]);

  useEffect(() => {
    if (ids.length > 0 && data.length > 0) {
      const selectedNames = data
        .filter((item) => ids.includes(item.id))
        .map((item) => item.name);
      setSelectedNames(selectedNames);
      setSelectedIds(ids);
    }
  }, [ids, data]);

  return (
    <div>
      <FormControl margin={margin} fullWidth>
        <InputLabel
          id="demo-mutiple-checkbox-label"
          style={{ marginLeft: '15px' }}
        >
          {label}
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          label={label}
          value={selectedIds}
          onChange={onChangeHandler}
          renderValue={(selected) =>
            (selected || [])
              .map((id) => data.find((d) => d.id === id)?.name)
              .filter(Boolean)
              .join(',')
          }
          input={<OutlinedInput label={label} />}
          MenuProps={menuProps}
        >
          {data.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              <Checkbox checked={selectedIds.indexOf(item.id) > -1} />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
